// 戴冠獣の幕ごとのテンポ (2026-10-08 ユーザー「その分1幕は攻撃のテンポを落として殴れる時間を増やして、
//   2幕では攻撃のテンポを上げて耐える時間を長くする感じで調整して」・検収 kensyu-hound-triple.html の気づいたこと)。
//
// 戴冠獣のテンポを決めている数値 (詳しくは docs/research/2026-10-08-hound-tempo-by-act.md):
//   ① 次の攻撃までの待ち = 待機に入ってから次の溜めに入るまで。boss.ts attackGapMsFor =
//      BOSS.idleGapMinMs〜idleGapMaxMs (150〜350ms・攻撃ごとに決まった揺れ) × 定義の idleGapMul (1.9)
//      × 最後の幕だけ finalRoomTempoMul (戴冠獣は未指定 = 1)。今は 285〜665ms。
//      その間に間合い (attackCommitRange 210) の外なら歩いて詰める (270px/s)。
//   ② 技ごとの硬直 (recoveryMs・噛み 560 / 突進牙 620 / 払い 650 / 尾 700 / のしかかり 1100)。
//   ③ 連の拍間 (gapMs・噛み→のしかかり 450 / 払い→突進牙 300) と2拍目以降の溜め (chargeOverrideMs)。
//   ④ 技ごとの溜め (chargeMs) = 見て反応する時間。ユーザーが溜めの見分けに苦労しているので触らない。
//
// ここで動かすのは ① だけ (幕1は長く=殴れる時間を増やす・幕2は短く=耐える時間を長く)。②③④ は今のまま。
//   幕1/幕2 の倍率は resolveHoundKit (hound_kit.ts) が定義の idleGapMul / finalRoomTempoMul に入れる
//   (戴冠獣は roomCount 2 = 幕2 が最後の幕なので finalRoomTempoMul がちょうど幕2だけに掛かる)。
//
// 段: now = 今のまま (三連を外しただけ) / a = 推奨 / b = 差を大きく。
//   10-08 検収 kensyu-hound-tempo.html：幕1・幕2とも a が「ちょうどいい」(now＝幕1「もっとゆったり」・幕2「もっと速く」／b＝幕1「もっと速く」・幕2「もっとゆったり」)
//   ＝配布版の既定は a。比較は DEV の ?houndTempo=now|b。
export type HoundTempo = 'now' | 'a' | 'b'

export const HOUND_TEMPO: Record<HoundTempo, { act1GapMul: number; act2GapMul: number }> = {
  now: { act1GapMul: 1, act2GapMul: 1 },
  // 幕1 285〜665 → 485〜1130ms (平均 +330ms)・幕2 285〜665 → 143〜333ms (平均 −240ms)。
  a: { act1GapMul: 1.7, act2GapMul: 0.5 },
  // 幕1 → 713〜1663ms (平均 +710ms)・幕2 → 71〜166ms (平均 −355ms・ほぼ待たずに次の溜め)。
  b: { act1GapMul: 2.5, act2GapMul: 0.25 },
}

let tempo: HoundTempo = 'a'
export function houndTempo(): HoundTempo { return tempo }
// game.ts の DEV の URL ブロックとテストから呼ぶ。知らない値は無視する。
export function setHoundTempo(value: string | null | undefined): void {
  if (value === 'now' || value === 'a' || value === 'b') tempo = value
}
